module.exports = __webpack_public_path__ + "img/signature_background.882c6e1.svg";